import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/settings/data-sources")({
  component: SettingsDataSources,
});

function SettingsDataSources() {
  return (
    <div className="p-4 xl:p-6">
      <p className="text-sm text-muted-foreground">全局数据连接管理开发中...</p>
    </div>
  );
}
